import React from 'react';

const SortIcon = () => {
    return (
        <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.39891 5.75L3.9348 0.5L0.470703 5.75H7.39891ZM7.39891 10.25L3.9348 15.5L0.470703 10.25H7.39891Z" fill="#7B93AF" />
        </svg>
    )
}

export default SortIcon;